function Icon({ children }) {
  return <span className="material-icons" aria-hidden="true">{children}</span>
}

function Metric({ label, value, note, href, tone, icon }) {
  return (
    <a className={`admin-dashboard-metric admin-dashboard-metric--${tone}`} href={href}>
      <span className="admin-dashboard-metric__icon"><Icon>{icon}</Icon></span>
      <span className="admin-dashboard-metric__body">
        <span className="admin-dashboard-metric__label">{label}</span>
        <span className="admin-dashboard-metric__value">
          <strong>{value.toLocaleString('ja-JP')}</strong>
          <small>件</small>
        </span>
        <span className="admin-dashboard-metric__note">{note}</span>
      </span>
      <Icon>arrow_forward</Icon>
    </a>
  )
}

export default function AdminDashboard({ period, metrics, links, skills = [] }) {
  const registrationTotal = metrics.preRegistrations + metrics.registrations
  const registrationRatio = registrationTotal > 0
    ? Math.round((metrics.registrations / registrationTotal) * 100)
    : 0

  return (
    <main className="admin-dashboard">
      <header className="admin-dashboard-header">
        <div>
          <p className="admin-dashboard-eyebrow">OPERATIONS OVERVIEW</p>
          <h1>ダッシュボード</h1>
          <p className="admin-dashboard-lead">登録から応募まで、期間内の動きをまとめて確認できます。</p>
        </div>

        <form className="admin-dashboard-period" method="get" action="/admin">
          <label>
            <span>開始日</span>
            <input type="date" name="from" defaultValue={period.from} max={period.to} />
          </label>
          <span className="admin-dashboard-period__separator" aria-hidden="true">—</span>
          <label>
            <span>終了日</span>
            <input type="date" name="to" defaultValue={period.to} min={period.from} />
          </label>
          <button type="submit"><Icon>search</Icon>集計する</button>
        </form>
      </header>

      <section className="admin-dashboard-flow" aria-label={`${period.label}の集計`}>
        <div className="admin-dashboard-flow__heading">
          <div>
            <span className="admin-dashboard-section-label">ACTIVITY FLOW</span>
            <h2>期間内の動き</h2>
          </div>
          <time>{period.label}</time>
        </div>

        <div className="admin-dashboard-metrics">
          <Metric
            label="仮登録者数"
            value={metrics.preRegistrations}
            note="未確認の登録者を表示"
            href={links.preRegistrations}
            tone="amber"
            icon="person_add"
          />
          <Metric
            label="本登録者数"
            value={metrics.registrations}
            note="本登録した人材を表示"
            href={links.registrations}
            tone="blue"
            icon="how_to_reg"
          />
          <Metric
            label="応募数"
            value={metrics.applications}
            note="期間内の応募を表示"
            href={links.applications}
            tone="mint"
            icon="send"
          />
        </div>
      </section>

      <div className="admin-dashboard-grid">
        <section className="admin-dashboard-panel admin-dashboard-conversion">
          <div className="admin-dashboard-panel__heading">
            <div>
              <span className="admin-dashboard-section-label">REGISTRATION MIX</span>
              <h2>登録状況</h2>
            </div>
            <strong>{registrationRatio}<small>%</small></strong>
          </div>
          <p>期間内の登録イベントに占める本登録の割合</p>
          <div className="admin-dashboard-conversion__track" aria-label={`本登録 ${registrationRatio}%`}>
            <span style={{ width: `${registrationRatio}%` }} />
          </div>
          <dl>
            <div><dt><i className="is-pre" />仮登録</dt><dd>{metrics.preRegistrations.toLocaleString('ja-JP')}</dd></div>
            <div><dt><i className="is-registered" />本登録</dt><dd>{metrics.registrations.toLocaleString('ja-JP')}</dd></div>
          </dl>
        </section>

        <section className="admin-dashboard-panel admin-dashboard-skills">
          <div className="admin-dashboard-panel__heading">
            <div>
              <span className="admin-dashboard-section-label">SKILL SIGNALS</span>
              <h2>スキル別分布</h2>
            </div>
            <span className="admin-dashboard-panel__caption">本登録者 / 上位10件</span>
          </div>

          {skills.length > 0 ? (
            <ol>
              {skills.map((skill) => (
                <li key={skill.id}>
                  <a href={skill.href}>
                    <span className="admin-dashboard-skills__name">{skill.name}</span>
                    <span className="admin-dashboard-skills__bar"><i style={{ width: `${skill.ratio}%` }} /></span>
                    <strong>{skill.count}<small>人</small></strong>
                    <Icon>chevron_right</Icon>
                  </a>
                </li>
              ))}
            </ol>
          ) : (
            <div className="admin-dashboard-empty">
              <Icon>query_stats</Icon>
              <p>この期間に本登録した人材のスキルデータはありません。</p>
            </div>
          )}
        </section>
      </div>
    </main>
  )
}
